import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Row, Col, Modal, ModalBody, ModalHeader, ModalFooter, Button, Pagination, PaginationItem, PaginationLink, Input, InputGroup, InputGroupText } from "reactstrap";
import { WhiteForm, OutputRow, BoldLabel, PrimaryButton, EditIcon, PinkButtonContainer, Colors, HighlightedInput } from "../../../utils/budget-tool-specific";
import { GetDB, generateGUID, auth } from "../../../utils/database/firebase-budget-tool";
import { listenToCollection, setDocument, updateDocumentProperty, deleteDocument } from "../../../utils/firestore-functions";
import firebase from "firebase/compat/app";

// Environment detection function
const getEnvironment = () => {
    var loc = window.location.href;
    if (loc.includes("localhost")){
      return "dev";
    }
    else if (loc.includes("test.deleptual")){
      return "dev";
    }
    else if (loc.includes("deleptual")){
      return "dev";
    }
    else if (loc.includes("moniker-virtual")){
      return "production";
    }
    return "production"; // Default to production for safety
};

const FlightsList = () => {

    const [guideList, setGuideList] = useState({});
    const [sortedList, setSortedList] = useState({});
    const [deleteID, setDeleteID] = useState("");
    const [textInput, setTextInput] = useState("");
    const [isProcessing, setIsProcessing] = useState(false);
    const [processingMessage, setProcessingMessage] = useState("");

    const budgetDB = GetDB();

    const [currentPage, setCurrentPage] = useState(0);
    const [recordsPerPage] = useState(15);

    const nPages = Math.ceil(Object.entries(sortedList).length / recordsPerPage);

    // N8N webhook URL - N8N will process the text and call Firebase functions
    const N8N_WEBHOOK_URL = "https://deleptual.app.n8n.cloud/webhook/cb82e0ef-91c7-4d3b-b452-0621c3eadcb4";

    const sendToN8N = async () => {
        if (!textInput.trim()) {
            setProcessingMessage("Please enter some text to process.");
            return;
        }

        setIsProcessing(true);
        setProcessingMessage("Processing your text...");

        try {
            const response = await fetch(N8N_WEBHOOK_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    text: textInput,
                    timestamp: new Date().toISOString(),
                    userId: auth.currentUser?.uid || 'anonymous'
                })
            });

            if (response.ok) {
                setProcessingMessage("Text sent successfully! Processing flight guide...");
                setTextInput(""); // Clear the input after successful send
                // Optionally refresh the list after a delay
                setTimeout(() => {
                    setProcessingMessage("");
                }, 3000);
            } else {
                setProcessingMessage("Error sending text. Please try again.");
            }
        } catch (error) {
            console.error('Error sending to N8N:', error);
            setProcessingMessage("Error sending text. Please check your connection and try again.");
        } finally {
            setIsProcessing(false);
        }
    };

    useEffect (() =>{
        var unsubscribe = listenToCollection(budgetDB, "flightGuides", SetLists);
        return unsubscribe;
    }, [])

    const SetLists = (guides) => {
        
        let x = guides.reduce((accumulator, value) => { 
            return {...accumulator,  [value.id]: value}
        }, {});
        setGuideList(x); 
        setSortedList(Object.fromEntries(Object.entries(x).sort(function(a, b){
            return b[1].lastModification - a[1].lastModification;
        })));

        Object.entries(x).sort(function(a, b){
            return b[1].lastModification - a[1].lastModification;
        }).slice(1,9);

        
    }

    const openGuide = (id) => {
        const timeStamp = firebase.firestore.Timestamp.now().toDate();
        updateDocumentProperty(budgetDB, "flightGuides", id, "lastModification", timeStamp);
        window.location = "/budget-app/flights/edit/" + id;
    }

    const createNewGuide = () => {
        const newTitle = "Flight Guide " + (Object.keys(guideList).length +  1); 
        const timeStamp = firebase.firestore.Timestamp.now().toDate();

        let newExperience = {
            title: newTitle,
            destination: "",
            departureDate: "",
            returnDate: "",
            travelFee: 0,
            currency: "CAD$",
            flights: [],
            lastModification: timeStamp,
            id: generateGUID(),
        }

        const openNewGuide = () => {
            openGuide(newExperience.id);
        }

        setDocument(budgetDB, "flightGuides", newExperience.id, newExperience, openNewGuide); 
    }

    const copyGuide = (guide) => {
        const newTitle = guide.title + " (Copy)";
        const timeStamp = firebase.firestore.Timestamp.now().toDate();
        
        let newGuide = {
            ...guide,
            title: newTitle,
            lastModification: timeStamp,
            id: generateGUID(),
        };

        const openNewGuide = () => {
            openGuide(newGuide.id);
        }

        setDocument(budgetDB, "flightGuides", newGuide.id, newGuide, openNewGuide);
    }

    const deleteGuide = async (id) => {
        toggleDeleteModal();
        console.log("deleting " + deleteID );
        deleteDocument(budgetDB, "flightGuides", deleteID);          
    }

    const confirmDelete = (id) => {
        toggleDeleteModal();
        setDeleteID(id);
    }

    const [modal, setModal] = useState(false);

    const toggleDeleteModal = () => setModal(!modal);

    const navigateToPage = (e, i) => {
        setCurrentPage(i);
    }

    return (

        <React.Fragment>
            <Modal isOpen={modal} toggle={toggleDeleteModal}>
                <ModalHeader toggle={toggleDeleteModal}>Are you sure you would like to delete this guide?</ModalHeader>
                <ModalBody>
                Once you've deleted this guide, you will not be able to access it again. All guide data will be lost.
                </ModalBody>
                <ModalFooter>
                <PrimaryButton onClick={x => deleteGuide(deleteID)} >
                    Delete Guide
                </PrimaryButton>{' '}
                <Button onClick={toggleDeleteModal}>
                    Cancel
                </Button>
                </ModalFooter>
            </Modal>
            <Row>
                <Col>
                    <div style={{marginRight: "15px", marginLeft: "15px", marginTop: "30px"}}>
                        {/* Only show Process Flight Information in development */}
                        {false && getEnvironment() === "dev" && (
                            <div style={{
                                background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                                borderRadius: "12px",
                                padding: "20px",
                                border: "1px solid #dee2e6",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                width: "100%"
                            }}>
                                        <div style={{marginBottom: "15px"}}>
                                            <BoldLabel style={{color: Colors.primary, fontSize: "16px", marginBottom: "8px"}}>
                                                ✈️ Process Flight Information
                                            </BoldLabel>
                                            <p style={{
                                                fontSize: "14px", 
                                                color: "#6c757d", 
                                                margin: "0",
                                                lineHeight: "1.4"
                                            }}>
                                                Paste or type flight details, itineraries, or any travel information below. Our AI will process it and create a flight guide for you.
                                            </p>
                                        </div>
                                        
                                        <InputGroup style={{marginBottom: "15px"}}>
                                            <Input
                                                type="textarea"
                                                placeholder="Paste your flight information here... (e.g., flight numbers, dates, destinations, etc.)"
                                                value={textInput}
                                                onChange={(e) => setTextInput(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter' && e.ctrlKey) {
                                                        e.preventDefault();
                                                        sendToN8N();
                                                    }
                                                }}
                                                style={{
                                                    minHeight: "120px",
                                                    resize: "vertical",
                                                    border: "2px solid #e9ecef",
                                                    borderRadius: "8px",
                                                    padding: "15px",
                                                    fontSize: "14px",
                                                    fontFamily: "inherit",
                                                    transition: "border-color 0.2s ease",
                                                    backgroundColor: "white"
                                                }}
                                                disabled={isProcessing}
                                            />
                                        </InputGroup>
                                        
                                        {processingMessage && (
                                            <div style={{
                                                padding: "10px 15px",
                                                borderRadius: "6px",
                                                marginBottom: "15px",
                                                backgroundColor: processingMessage.includes("Error") ? "#f8d7da" : "#d1ecf1",
                                                border: `1px solid ${processingMessage.includes("Error") ? "#f5c6cb" : "#bee5eb"}`,
                                                color: processingMessage.includes("Error") ? "#721c24" : "#0c5460"
                                            }}>
                                                <div style={{display: "flex", alignItems: "center"}}>
                                                    <span style={{marginRight: "8px"}}>
                                                        {processingMessage.includes("Error") ? "⚠️" : "🔄"}
                                                    </span>
                                                    <span style={{fontSize: "14px", fontWeight: "500"}}>
                                                        {processingMessage}
                                                    </span>
                                                </div>
                                            </div>
                                        )}
                                        
                                        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                            <div style={{fontSize: "12px", color: "#6c757d"}}>
                                                💡 Tip: Use Ctrl+Enter to quickly process your text
                                            </div>
                                            <PrimaryButton 
                                                onClick={sendToN8N}
                                                disabled={isProcessing || !textInput.trim()}
                                                style={{
                                                    background: isProcessing || !textInput.trim() ? "#6c757d" : Colors.primary,
                                                    border: "none",
                                                    borderRadius: "8px",
                                                    padding: "12px 24px",
                                                    fontSize: "14px",
                                                    fontWeight: "600",
                                                    transition: "all 0.2s ease",
                                                    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                                    minWidth: "140px",
                                                    color: "white"
                                                }}
                                                onMouseEnter={(e) => {
                                                    if (!isProcessing && textInput.trim()) {
                                                        e.target.style.transform = "translateY(-1px)";
                                                        e.target.style.boxShadow = "0 4px 8px rgba(0,0,0,0.15)";
                                                        e.target.style.background = Colors.primaryDark;
                                                    }
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.transform = "translateY(0)";
                                                    e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
                                                }}
                                            >
                                                {isProcessing ? (
                                                    <span>
                                                        <span style={{marginRight: "8px"}}>⏳</span>
                                                        Processing...
                                                    </span>
                                                ) : (
                                                    <span>
                                                        <span style={{marginRight: "8px"}}>🚀</span>
                                                        Process Text
                                                    </span>
                                                )}
                                            </PrimaryButton>
                                        </div>
                                    </div>
                        )}
                        <div style={{
                            background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
                            borderRadius: "12px",
                            padding: "20px",
                            border: "1px solid #dee2e6",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                            marginTop: "20px",
                            width: "100%"
                        }}>
                            <div style={{marginBottom: "20px"}}>
                                <BoldLabel style={{color: Colors.primary, fontSize: "18px", marginBottom: "8px"}}>
                                    📋 Flight Guides
                                </BoldLabel>
                                <p style={{
                                    fontSize: "14px", 
                                    color: "#6c757d", 
                                    margin: "0",
                                    lineHeight: "1.4"
                                }}>
                                    Manage your flight guides and itineraries. Create new guides or edit existing ones.
                                </p>
                            </div>
                            
                            <div style={{
                                background: "white",
                                borderRadius: "8px",
                                padding: "15px",
                                border: "1px solid #e9ecef"
                            }}>
                                <div style={{
                                    display: "grid",
                                    gridTemplateColumns: "2fr 2fr 120px auto",
                                    gap: "20px",
                                    alignItems: "center",
                                    paddingBottom: "15px",
                                    borderBottom: "1px solid #e9ecef",
                                    marginBottom: "15px"
                                }}>
                                    <div>
                                        <span style={{fontWeight: "600", color: Colors.primary}}>Title</span>
                                    </div>
                                    <div>
                                        <span style={{fontWeight: "600", color: Colors.primary}}>Date Modified</span>
                                    </div>
                                    <div>
                                        {/* Space for action buttons */}
                                    </div>
                                    <PrimaryButton 
                                        onClick={createNewGuide}
                                        style={{
                                            background: Colors.primaryAccent,
                                            border: "none",
                                            borderRadius: "8px",
                                            padding: "10px 20px",
                                            fontSize: "14px",
                                            fontWeight: "600",
                                            transition: "all 0.2s ease",
                                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                            color: Colors.primaryDark
                                        }}
                                        onMouseEnter={(e) => {
                                            e.target.style.transform = "translateY(-1px)";
                                            e.target.style.boxShadow = "0 4px 8px rgba(0,0,0,0.15)";
                                        }}
                                        onMouseLeave={(e) => {
                                            e.target.style.transform = "translateY(0)";
                                            e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
                                        }}
                                    >
                                        ✨ Create New Guide
                                    </PrimaryButton>
                                </div>
                                {sortedList !== undefined && Object.entries(sortedList).slice(currentPage * recordsPerPage,
                                (currentPage + 1) * recordsPerPage).map((guide, i) => (
                                    <div key={i} style={{
                                        display: "grid",
                                        gridTemplateColumns: "2fr 2fr 120px auto",
                                        gap: "20px",
                                        alignItems: "center",
                                        padding: "12px 0",
                                        borderBottom: "1px solid #f1f3f4",
                                        transition: "background-color 0.2s ease",
                                        backgroundColor: "transparent"
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = "#f8f9fa";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = "transparent";
                                    }}
                                    >
                                        <div>
                                            <p style={{
                                                margin: "0",
                                                fontWeight: "500",
                                                color: Colors.primary,
                                                fontSize: "14px"
                                            }}>
                                                {guide[1].title}
                                            </p>
                                        </div>
                                        <div>
                                            <p style={{
                                                margin: "0",
                                                color: "#6c757d",
                                                fontSize: "13px"
                                            }}>
                                                {(guide[1].lastModification !== undefined && guide[1].lastModification !== "") ? 
                                                    guide[1].lastModification.toDate().toLocaleString("en-US") : 
                                                    ""}
                                            </p>
                                        </div>
                                        <div style={{
                                            display: "flex",
                                            gap: "8px",
                                            alignItems: "center"
                                        }}>
                                            <button
                                                onClick={(x) => openGuide(guide[1].id)}
                                                style={{
                                                    background: "transparent",
                                                    border: "none",
                                                    padding: "8px",
                                                    borderRadius: "6px",
                                                    cursor: "pointer",
                                                    color: Colors.primaryAccent,
                                                    transition: "all 0.2s ease"
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor = Colors.primaryAccent;
                                                    e.currentTarget.style.color = "white";
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor = "transparent";
                                                    e.currentTarget.style.color = Colors.primaryAccent;
                                                }}
                                                title="Edit Guide"
                                            >
                                                ✏️
                                            </button>
                                            <button
                                                onClick={(x) => copyGuide(guide[1])}
                                                style={{
                                                    background: "transparent",
                                                    border: "none",
                                                    padding: "8px",
                                                    borderRadius: "6px",
                                                    cursor: "pointer",
                                                    color: Colors.primaryAccent,
                                                    transition: "all 0.2s ease"
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor = Colors.primaryAccent;
                                                    e.currentTarget.style.color = "white";
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor = "transparent";
                                                    e.currentTarget.style.color = Colors.primaryAccent;
                                                }}
                                                title="Copy Guide"
                                            >
                                                📋
                                            </button>
                                            <button
                                                onClick={(x) => confirmDelete(guide[1].id)}
                                                style={{
                                                    background: "transparent",
                                                    border: "none",
                                                    padding: "8px",
                                                    borderRadius: "6px",
                                                    cursor: "pointer",
                                                    color: "#dc3545",
                                                    transition: "all 0.2s ease"
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.backgroundColor = "#dc3545";
                                                    e.currentTarget.style.color = "white";
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.backgroundColor = "transparent";
                                                    e.currentTarget.style.color = "#dc3545";
                                                }}
                                                title="Delete Guide"
                                            >
                                                🗑️
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div style={{
                            background: "white",
                            borderRadius: "8px",
                            padding: "15px",
                            border: "1px solid #e9ecef",
                            marginTop: "15px"
                        }}>
                            <div style={{textAlign: "center"}}>
                                <SPagination style={{
                                    justifyContent: "center",
                                    margin: "0"
                                }}>
                                    <SPaginationItem disabled={currentPage <= 0}>
                                        <SPaginationLink
                                        onClick={e => navigateToPage(e, 0)}
                                        first
                                        href="#"
                                        />
                                    </SPaginationItem>
                                    <SPaginationItem disabled={currentPage <= 0}>
                                        <SPaginationLink
                                        
                                        onClick={e => navigateToPage(e, currentPage-1)}
                                        href="#"
                                        previous
                                        />
                                    </SPaginationItem>
                                    {[...Array(nPages)].map((page, i) => 
                                    <SPaginationItem active={i === currentPage} key={i}>
                                        <SPaginationLink  active={i === currentPage} onClick={e => navigateToPage(e, i)} href="#">
                                        {i + 1}
                                        </SPaginationLink>
                                    </SPaginationItem>
                                    )}

                                    <SPaginationItem disabled={currentPage+1 >= nPages}>
                                        <SPaginationLink
                                        onClick={e => navigateToPage(e, currentPage+1)}
                                        href="#"
                                        next
                                        />
                                    </SPaginationItem>
                                    <SPaginationItem disabled={currentPage+1 >= nPages}>
                                        <SPaginationLink
                                        onClick={e => navigateToPage(e, nPages-1)}
                                        href="#"
                                        last
                                        />
                                    </SPaginationItem>
                                </SPagination>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default FlightsList;

const SPagination = styled(Pagination)`
    
`

const SPaginationItem = styled(PaginationItem)`

    ${props => props.active && `
            color: white;
            background-color: black;
    `}

`
const SPaginationLink = styled(PaginationLink)`
    color: ${Colors.primaryAccent};
    &:hover {
        color: ${Colors.primaryDark};
    }
    ${props => props.active && `
            color: white;
            background-color: ${Colors.primaryAccent} !important;
            border-color: ${Colors.primaryAccent} !important;
    `}
`;